/**
 * Name: Login
 * Author: @Gaurav
 * Date: 19-07-2021
 */
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

// Components
import Button from '../../components/Button';
import { _showAlert } from '../../utils';

// Styles
import './LoginStyle.scss';

// Images
import UPPER_LOGIN from './../../assets/upperLogin-image.png';
import USER_ICN from './../../assets/user_icn.svg';
import EYE_ICN from './../../assets/eye_icn.svg';
import HIDE_EYE from './../../assets/hide-private-hidden.svg';
import PASSWORD_ICN from './../../assets/password_icn.svg';

import { userStore } from '../../store';
import { userActions } from '../../actions';

const Form = () => {
  const history = useHistory();

  const [username, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorUsername, setErrorUserName] = useState('');
  const [errorPassword, setErrorPassword] = useState('');
  const [isRevealPassword, setIsRevealPassword] = useState(false);
  const [readoOnlyFields, setReadOnlyFields] = useState({
    username: true,
    password: true,
  });

  // Zustand User Store
  const { setUser } = userStore((state) => ({
    setUser: state.setUser,
  }));

  /**
   * it will handle the login api request and submit validation
   */
  const handleSubmitLogin = (e) => {
    e.preventDefault();
    setLoading(true);

    if (username === '') {
      setLoading(false);
      setErrorUserName('Please fill your Username');
    } else if (password === '') {
      setLoading(false);
      setErrorPassword('Please fill your Password');
    } else if (password.length < 8) {
      setLoading(false);
      setErrorPassword('Password must be 8 character long');
    } else {
      const LoginUser = async () => {
        const loginUserResponse = await userActions.loginUser({ email: username, password: password });

        if (loginUserResponse && loginUserResponse.code === 'OK') {
          setUser(loginUserResponse?.data);
          setLoading(false);
          _showAlert('Login Successfully', 'success', 4000);
          sessionStorage.setItem('authData', JSON.stringify(loginUserResponse));
          sessionStorage.setItem('expiration_time', new Date().getTime() + 10 * 60 * 1000);
          setTimeout(() => history.push('/songs/add-songs'), 500);
        } else {
          _showAlert('Wrong email or Password', 'error', 4000);
          setLoading(false);
          setUserName('');
          setPassword('');
        }
      };

      LoginUser();
    }
  };

  const handleChange = (e, text) => {
    if (text === 'username') {
      setUserName(e.target.value);
      setErrorUserName('');
    } else if (text === 'password') {
      setPassword(e.target.value);
      setErrorPassword('');
    }
  };

  return (
    <div className="wrap_content">
      <div className="login_logo">
        <img src={UPPER_LOGIN} />
      </div>
      <h2>Login to 4Play admin</h2>
      <p className="fnt13">Enter to continue and explore within your grasp</p>
      <form className="login_form" onSubmit={handleSubmitLogin}>
        <div className="input-main-warpper">
          <div className="wrap_field">
            <input
              placeholder="User Name"
              className="login_field"
              value={username}
              onChange={(e) => handleChange(e, 'username')}
              required
              readOnly={readoOnlyFields.username}
              onFocus={() => setReadOnlyFields({ ...readoOnlyFields, username: false })}
              name="username"
            />
            <img src={USER_ICN} />
          </div>
          <label className="input-error-message">{errorUsername}</label>
        </div>
        <div className="input-main-warpper">
          <div className="wrap_field">
            <input
              placeholder="Password"
              className="login_field"
              type={isRevealPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => handleChange(e, 'password')}
              readOnly={readoOnlyFields.password}
              onFocus={() => setReadOnlyFields({ ...readoOnlyFields, password: false })}
            />
            <img src={PASSWORD_ICN} />
            <img
              className="open_eye"
              title={isRevealPassword ? 'Hide password' : 'Show password'}
              src={isRevealPassword ? EYE_ICN : HIDE_EYE}
              onClick={() => setIsRevealPassword(!isRevealPassword)}
            />
          </div>
          <label className="input-error-message">{errorPassword}</label>
        </div>
        <Button type="submit" isLoading={loading} className="login_btn">
          Log in to continue
        </Button>
      </form>
    </div>
  );
};
export default Form;
